import { Component, OnInit, signal, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { UserService } from '@eadsysteme/ewsauthclient-v1';
import { KeycloakService } from 'src/app/auth/keycloak.service';
import { Icons } from '../../../util/Icons';
import { LayoutService } from '../../../../@vex/services/layout.service';
import { SnackbarService } from '../../../services/snackbar.service';
import { AraSpinnerButtonComponent } from '../../util/ara-spinner-button/ara-spinner-button.component';

@Component({
	selector: 'vex-update-password',
	templateUrl: './update-password.component.html',
	styleUrl: './update-password.component.scss',
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [TranslocoDirective, AraSpinnerButtonComponent],
})
export class UpdatePasswordComponent implements OnInit {
	translocoService = inject(TranslocoService);
	private readonly userService = inject(UserService);
	private readonly layoutService = inject(LayoutService);
	private readonly snackbar = inject(SnackbarService);
	icons = inject(Icons);
	private readonly keycloak = inject(KeycloakService);

	isMobile = signal(false);
	waitingForMailToBeSent = signal(false);

	ngOnInit(): void {
		this.isMobile.set(this.layoutService.isMobile());
	}

	sendUpdatePasswordMail() {
		const userId = this.keycloak.getKeycloakInstance().tokenParsed.sub;
		this.waitingForMailToBeSent.set(true);
		this.userService.sendOwnPasswordResetEmail(userId, globalThis.location.origin).subscribe(
			(response) => {
				this.snackbar.success(this.translocoService.translate('userProfile.sentUpdatePasswordMail'));
				this.waitingForMailToBeSent.set(false);
			},
			(err) => {
				this.snackbar.error(this.translocoService.translate('errors.passwordUpdate'));
				this.waitingForMailToBeSent.set(false);
			}
		);
	}
}
